<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.details.first_name }} {{ activeUserInfo.details.last_name }}</p>
      <small>{{name}}</small>
      <small> ({{role.toUpperCase()}}) </small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <img v-if="activeUserInfo.photoURL" key="onlineImg" :src="activeUserInfo.photoURL" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/pages/profile').catch(() => {})">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>

import url from '@/services/urlService';

export default {
  data () {
    return {
      subdomain: '',
      name: '',
      role: '',
    }
  },
  computed: {
    activeUserInfo () {
      let data=this.$store.state.AppActiveUser;
      return data;
    },
    current_organization() {
      return this.$store.getters['organization/organization_details'];
    },
  },
  methods: {
    logout () {
      this.$store.commit('RESET_STATE');
      url.rawRedirect('login');
    }
  },
  async mounted(){
    let user_id = this.$store.state.user.id;
    let org_id = this.$store.state.user.current_organization;
    await this.$store.dispatch('organization/getCurrentOrganization', {
      organization_id: org_id,
      user_id: user_id, 
    });
    let org = JSON.parse(JSON.stringify(this.$store.state.organization.current_organization[0]));
    console.log("organizati")
    console.log(org);
    this.subdomain = org.subdomain || '';
    this.name = org.name || '';
    this.role = org.role || '';
  }
}
</script>
